<template>
    <span class="tag is-warning is-light ml-2">
        <span class="icon is-small">
            <i class="fas fa-low-vision"></i>
        </span>
        <span>{{ translate("page.event_details.private_tournament_badge") }}</span>
    </span>
</template>

<script setup lang="ts">
    import { translate } from "./translations";
</script>

<style scoped></style>
